import {useQueryClient} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import {ClipType, UserMeClipType} from '../../../core/entities/clip/constants';
import {filterByClipType} from '../../../core/factories/clips/filterByClipType';
import {getClipsFromPages} from '../../../core/factories/clips/getClipsFromPages';
import {useInfiniteMyClips} from '../../../core/repositories/clipsRepository';

const clipTypeMapping: Record<ClipType, string> = {
  [ClipType.REPORT]: `${UserMeClipType.SELECTION_REPORT},${UserMeClipType.ENTRY_SHEET}`,
  [ClipType.POST]: `${UserMeClipType.COMPANY_COLUMN},${UserMeClipType.COLUMN}`,
} as const;

function getClipTypes(clipType: ClipType): string {
  return clipTypeMapping[clipType];
}

export function useInfiniteFilteredClips(clipType: ClipType, limit = 10) {
  const [pageCount, setPageCount] = useState<number>(1);

  const clipTypes = getClipTypes(clipType);

  const queryClient = useQueryClient();
  const {data, isFetching, fetchNextPage, hasNextPage, isFetchingNextPage} =
    useInfiniteMyClips({
      limit,
      page: pageCount,
      clipTypes,
    });

  useEffect(() => {
    // MEMO:初回レンダリング時にのみ実行
    if (pageCount === 1) {
      // MEMO:キャッシュをリセット
      void queryClient.resetQueries([`myClips_${clipTypes}`]);
    }
  }, [queryClient, pageCount]);

  useEffect(() => {
    void fetchNextPage();
  }, [clipTypes, pageCount]);

  const loadMoreClips = () => {
    setPageCount(pageCount + 1);
  };

  const clips = getClipsFromPages(isFetching, data);
  const filteredClips = filterByClipType(clips, clipTypes);

  return {
    filteredClips,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    loadMoreClips,
  };
}
